import { render, staticRenderFns } from "./PopupBottomContainer.vue?vue&type=template&id=36eab424&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eab424",
  null
  
)

export default component.exports